export default "__VITE_ASSET__DN$j25yd__"